import {
  accordion
} from '../components/accordion';
import {
  headerSettings
} from '../components/header';
import {
  form
} from '../components/form';
import {
  teamSlider
} from '../components/sliders/slider-team';
import {
  ticker
} from '../components/ticker';
import {
  ourClients
} from '../components/ourClients';
import {
  stages
} from '../components/stages';
import {
  modals
} from '../components/modals';

document.addEventListener("DOMContentLoaded", () => {
  headerSettings();
  ticker();
  ourClients();
  stages();
  teamSlider();
  accordion();
  form();
  modals();
});


// WEBPACK FOOTER //
// app/scripts/pages/home.js